import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Fetch } from "../../../shared/Fetch";

export interface IWorkStreamFilter {
  fromDate?: Date | null;
  toDate?: Date | null;
  deadlineFromDate?: Date | null;
  deadlineToDate?: Date | null;
  categoryId?: number | null;
  assignedTo?: number | null;
  addedBy?: number | null;
  workstream_Category_ID?: number | null;
  status?: string | null;
}

const EmptyWorkStreamFilter: IWorkStreamFilter = {
  fromDate: null,
  toDate: null,
  deadlineFromDate: null,
  deadlineToDate: null,
  categoryId: null,
  assignedTo: null,
  addedBy: null,
  workstream_Category_ID: 0,
  status: "",
};

interface IProps {
  filter: IWorkStreamFilter;
  setFilter: (filter: IWorkStreamFilter) => void;
}
const Filter = (props: IProps) => {
  const [categories, setCategories] = useState<any[]>([]);
  const [assignedToUsers, setAssignedToUsers] = useState<any[]>([]);
  const [addedByUsers, setAddedByUsers] = useState<any[]>([]);
  const { control, reset, watch, handleSubmit } = useForm<IWorkStreamFilter>({ defaultValues: props.filter });
  const onSubmit = (data: IWorkStreamFilter) => {
    // console.log(data);
    // console.log("Submit");
    props.setFilter(data);
  };

  const loadCategories = async () => {
    const response = await Fetch("TenderWorkstream/GetWorkStreamCategory", "GET", null, null, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ id: 0, category_Name: "-- SELECT --" });
      setCategories(data);
    }
  };
  const loadAssignedToUsers = async (categoryId: number) => {
    const response = await Fetch("TenderWorkstream/GetUsersByWorkstreamCategory", "GET", null, `workstreamCategoryId=${categoryId}`, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setAssignedToUsers(data);
    } else {
      console.error("Failed to load assigned-to users", response?.status);
    }
  };

  const loadWorkstreamAddedByUser = async () => {
    const response = await Fetch("Tender_Mast/GetProposalWriterUser", "GET", null, null, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setAddedByUsers(data);
    }
  };

  useEffect(() => {
    loadCategories();
    loadWorkstreamAddedByUser();
  }, []);

  const selectedCategory = watch("categoryId");

  useEffect(() => {
    if (selectedCategory && selectedCategory > 0) {
      loadAssignedToUsers(selectedCategory);
    }
  }, [selectedCategory]);

  const workstreamTypeOption = [
    { name: "Master", value: 1 },
    { name: "Client Specific", value: 2 },
  ];
  const status_Name = [
    { name: "Created", value: "Created", color: "#64748B" },
    { name: "Assigned", value: "Assigned", color: "#3B82F6" },
    { name: "Pending", value: "Pending", color: "#F59E0B" },
    { name: "Received", value: "Received", color: "#8B5CF6" },
    { name: "Under Review", value: "Under Review", color: "#F97316" },
    { name: "Documentation Pending", value: "Documentation Pending", color: "#EAB308" },
    { name: "Completed", value: "Completed", color: "#22C55E" },
    { name: "Closed", value: "Closed", color: "#475569" },
  ];
  const statusTemplate = (option: any) => {
    if (!option) return <span>Select Status</span>;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <i
          className="pi pi-circle-fill"
          style={{
            color: option.color,
            fontSize: "0.6rem",
          }}
        />
        <span>{option.name}</span>
      </div>
    );
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVDate column={4} label="From Date" control={control} name="fromDate" />
        <JVDate column={4} label="To Date" control={control} name="toDate" />
        <JVDropdown column={4} label="Category" control={control} name="categoryId" options={categories} optionLabel="category_Name" optionValue="id" />
        <JVDropdown column={4} label="Work Stream Type" control={control} name="workstream_Type" options={workstreamTypeOption} optionLabel="name" optionValue="value" placeholder="Select Category" />
        <JVDropdown column={4} label="Status" control={control} name="status" options={status_Name} optionLabel="name" optionValue="value" placeholder="Select Status" itemTemplate={statusTemplate} valueTemplate={statusTemplate} />
        <JVDropdown filter column={4} label="Assigned To" control={control} name="assignedTo" options={assignedToUsers} optionLabel="user_Name" optionValue="login_ID" />
        <JVDropdown filter column={4} label="Added By" control={control} name="addedBy" options={addedByUsers} optionLabel="user_Name" optionValue="login_ID" />
        <JVDate column={4} label="Deadline From Date" control={control} name="deadlineFromDate" />
        <JVDate column={4} label="Deadline To Date" control={control} name="deadlineToDate" />
        <div className="col-12 flex justify-content-end gap-2">
          <Button label="Search" type="submit" />
          <Button
            type="button"
            label="Clear"
            className="p-button-outlined"
            onClick={() => {
              reset(EmptyWorkStreamFilter);
              props.setFilter(EmptyWorkStreamFilter);
            }}
          />
        </div>
      </form>
    </>
  );
};

export default Filter;
